import { Group } from '../../types/app/group.types';
import { api } from '../core/api';

export const getGroupList = () => api.get<Group[]>('Group/GetList').then((res) => res.data);
